module.exports = __webpack_public_path__ + "img/Muito-alem-dos-muros-1100x350.a2c0ff17.png";